<template>
  <v-navigation-drawer v-model="navState.drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list dense>
      <template v-for="item in displayableItems">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']"
          append-icon
        >
          <template v-slot:activator>
            <v-list-item :to="item.link" link>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.link" link>
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.link" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    items: [
      // { icon: "mdi-home", text: "Home", link: "/" },
      // {
      //   icon: "mdi-file-document-edit-outline",
      //   text: "Test Prep",
      //   link: "/prep",
      // },
      // {
      //   icon: "mdi-desk-lamp",
      //   text: "Select A Test",
      //   link: "/st"
      // },
      // {
      //   icon: "mdi-school",
      //   text: "Course Registration",
      //   link: "/cr"
      // },
      // {
      //   icon: "mdi-file-document-edit-outline",
      //   text: "Test Prep Vertical",
      //   link: "/prepv"
      // },
      { icon: "mdi-bookshelf", text: "Virtual Camp Sign Up", link: "/camp" },
      // { icon: "mdi-bookshelf", text: "Courses", link: "/shop" },
      // { icon: "mdi-information-outline", text: "About Us", link: "/about" },
      // {
      //   icon: 'mdi-chevron-up',
      //   'icon-alt': 'mdi-chevron-down',
      //   text: 'My Pages',
      //   model: true,
      //   children: [
      //     { icon: 'mdi-plus', text: 'My Order' },
      //   ],
      // },
      // { icon: "mdi-settings", text: "Settings", link: "/settings" },
      // { icon: "mdi-message", text: "Send feedback" },
      // { icon: "mdi-help-circle", text: "Help" }
    ]
  }),

  computed: {
    ...mapGetters(["navState", "isLoggedIn"]),
    displayableItems() {
      return this.items.filter(item => {
        return item.secured == null || (item.secured && this.isLoggedIn);
      });
    }
  }
};
</script>

<style></style>
